exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--10-1!@wfp/ui/assets/css/styles.min.css"), "");

// Module
exports.push([module.id, "\n", ""]);

